import { render, staticRenderFns } from "./InstantText.vue?vue&type=template&id=7ed2d075&"
import script from "./InstantText.vue?vue&type=script&lang=js&"
export * from "./InstantText.vue?vue&type=script&lang=js&"
import style0 from "./InstantText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports